import { filterObjectByKey } from '../utils/filterObjectByKey';
import { createBreadcrumbsList } from '../utils/createBreadcrumbsList';
import { calculatePaginatedPostIndex } from '../utils/calculatePaginatedPostIndex';
import { imageObject } from '../utils/imageObject';

import type { ListingPageStructuredDataArgsWithPagination } from '../types';

import config from '../structured_data.config.json';

const { website, organization } = config;

function blogListingAuthorPageStructuredData({
  name,
  urlSlug,
  baseUrl,
  image,
  breadcrumbs,
  totalPosts,
  postsPerPage,
  currentPage,
  abstract,
  collectionItems,
}: ListingPageStructuredDataArgsWithPagination) {
  const listingPageUrl = new URL(`/${baseUrl}/${urlSlug}`, website.url);

  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [
      // include type, name, and id only
      (({ '@type': type, name, '@id': id }) => ({ '@type': type, name, '@id': id }))(organization),
      filterObjectByKey(website, ['potentialAction']),
      imageObject({ image }),
      createBreadcrumbsList({ websiteUrl: website.url, baseUrl, urlSlug, breadcrumbs }),
      {
        '@type': 'CollectionPage',
        '@id': `${listingPageUrl}#webpage`,
        url: listingPageUrl,
        name,
        inLanguage: website.inLanguage,
        abstract,
        mainEntity: {
          '@type': 'ItemList',
          numberOfItems: totalPosts,
          itemListElement: collectionItems
            ? collectionItems
                .filter((item) => item.name && item.url)
                .map(({ name, url }, index) => ({
                  '@type': 'ListItem',
                  position: calculatePaginatedPostIndex(index, currentPage, postsPerPage),
                  name,
                  url: new URL(url, website.url).toString(),
                }))
            : [],
        },
        isPartOf: {
          '@id': website['@id'],
        },
        breadcrumb: {
          '@id': `${listingPageUrl}#breadcrumb`,
        },
      },
    ],
  });
}

export default blogListingAuthorPageStructuredData;
